import { TServerName } from 'models/types';

export const getCurrentPartId = ({ partId, serverName }: { partId?: string, serverName: TServerName}): number | string => {
  if (partId === '') {
    switch (serverName) {
      case 'tele2': return 1040087020;
      case 'beeline': return 1040081040;
      case 'kcell': return 1040084020;
      default: return '';
    }
  }

  return Number(partId);
};
